import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { jsx as ___EmotionJSX } from "@emotion/core";
var GraphQLProvider = _ref => {
  var children = _ref.children;
  var _useAllhomesContext = useAllhomesContext(),
    apolloClient = _useAllhomesContext.apolloClient;
  return apolloClient && ___EmotionJSX(ApolloProvider, {
    client: apolloClient
  }, children);
};
GraphQLProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default GraphQLProvider;